  <div v-if="isMatchedPersona">
    <slot></slot>
  </div>